// Slovenské dvojče locale/cs/searchWhisperer.js.
export default {
  suggests: 'Našepkávané dopyty',
  hint: '↑ ↓ pohyb · Enter otvorí',
  // rotující placeholder pole hledání: prefix + populární dotaz + suffix
  placeholderPrefix: 'Hľadať „',
  placeholderSuffix: '“',
};
